<template>
  <div>
    <div class="sectionHeader">
      <h5>Reviews</h5>
    </div>
    <div class="ratingContent whiteContainer">
      <ul style="list-style-type:none; margin:0; padding:0;">
        <li class="w3-row" v-for="(review, index) of item.reviews" :key="index">
          <div class="w3-col s2 w3-padding"><img style="width:100%; max-width:80px;" :alt="'review profile image'" :src="review.profile_photo_url" /></div>
          <div class="w3-col s10">
            <div class="rating-box">
              <div class="rating" :style="{width: (review.rating / 5 * 100) + '%'}"></div>
            </div>
            <div>{{review.text}}</div>
            <div class="w3-right-align" style="margin-top:4px;">- <a style="text-decoration:none;" :href="review.author_url" target="_blank" rel="noreferrer">{{review.author_name}}</a> <span style="margin-left:8px; font-size:10pt; color:#999;"><span style="font-style:italic">{{review.relative_time_description}}</span></span></div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'reviews',
  props: {
    item: Object
  },
  data() {
    return {
      width: window.innerWidth
    }
  },
  mounted() {
    window.onresize = () => {
      this.width = window.innerWidth
    }
  }
}
</script>

<style scoped>
  .ratingContent {padding:15px;}
  .ratingContent .w3-row {margin-bottom:8px; padding:8px 0; border-bottom: 1px solid #ddd}
  .ratingContent .w3-row:last-child {margin-bottom:0; padding-bottom:0; border-bottom: 0;}

  .rating-box {position:relative; vertical-align: middle; font-size: 1.5em; font-family: 'fa-regular'; display:inline-block; color: #ffca28;}
  .rating-box .rating {position: absolute; left:0; top:0; white-space:nowrap; font-family: 'fa-solid'; overflow:hidden; color: #ffca28;}
  .rating-box:before{content: "\f005\f005\f005\f005\f005";}
  .rating-box .rating:before {content: "\f005\f005\f005\f005\f005";}
</style>
